<template>
    <v-progress-circular v-bind="$attrs"></v-progress-circular>
</template>

<script>
export default {
    name: 'v-progress-circular-ext',
    components: {},
    data: () => ({}),
    watch: {
        '$attrs.value': function(newValue) {
            if (newValue >= 100) {
                const that = this;
                window.setTimeout(function() {
                    that.$emit('complete');
                }, 800);
            }
        },
    },
    methods: {},
};
</script>
